<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Zr9PqE/tc-custom/9781473815605.jpg?1701641774642" alt="This image is the cover for the book Jai Sixth!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jai Sixth!
      </h1>
      <p class="bookDescription body article font2">
        <p>This is the story of the 6th Queen Elizabeth's Own Gurkha Rifles from the Regiment raising in 1817 as the Cuttack Legion in the service of the Honourable East India Company until it's amalgamation with the 2nd King Edward VII's Gurkha Rifles ( The Sirmoor Rifles) to form the First Battalion of The Royal Gurkha Rifles in 1994.  In the course of its 177 years' existence the Regiment has had many changes of title, acquiring its present one in 1959 when it became 'Queen Elizabeths Own'.  In the days of the empire when men of many different races and religions served under the British Crown it was probably the Gurkha soldier who most captured the imagination of the British people, partially on account of his outstanding courage in battle, and partially because of his loyalty and sheer good humour.  Prior to Independence in 1947 the former Indian Army contained ten regiments of Gurkha Rifles, each of two battalions.  In 1948 four of these, of which the 6th Gurkha's was one, were transferred to the British Army.  The others remained in the Indian Army.  During the First World War the 6th greatly distinguished themselves at Gallipoli, and later Mesopotamia, Egypt, Persia, Salonika and Afghanistan.  In the Second World War the Regiment fought in all the main theatres except North-West Europe, particularly in Burma where the Third Battalion was awarded two Vcs in one battle when serving with Wingate's Chindits.  After the war the Regiment played a prominent part in Malaya during the Emergency, and later in Borneo during the confrontation with Indonesia.  As will be evident to the reader of this book, wherever they served the 6th lived up to the Gurkha philosophy that is is 'Better to doe then live a coward.  The book also bears out the assertion that Field Marshal Viscount Slim, himself an officer of the 6th, that the Gurkha is 'the ideal infantryman'.  Although it is sad that, owing to the reduction in strength of the British Army the 6th Gurkhas are being required to amalgamate with the equally distinguished 2nd Gurkhas, it is at least comforting that there will be Gurkhas serving in the Crown, as there have been since 1815.  Long may they continue to do so, but no longer will the stirring cry 'Jai Sixth! (Go Sixth) be heard on the battlefield or sports ground.  Royalties from sales of this book have been donated by the author to the 6th Gurkha's Benevolent Fund.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Lunt
      </h2>
      
      <p class="authorDescription body article">major General James Lunt is a military historian with many biographies and military histories to his credit. Although he has never served in a Gurkha regiment, he served with Gurkhas on many occasions during his service in India and Burma with his British Regiment and the Burma Rifles. He is an honorary M.A. of Oxford University, a Fellow of the Royal Historical Society, a Vice-President of the Society of Army Historical Research, and an Emeritus Fellow of Wadham Collage, oxford</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Leo Cooper
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5192dbc0